// extracted by mini-css-extract-plugin
export default {"label":"Input_label__U9NhE","label_span":"Input_label_span__jiRTQ","field":"Input_field__zyOC5"};